// extracted by mini-css-extract-plugin
export default {"root":"InvigilationSearch_root__4OU3P","input":"InvigilationSearch_input__2Wi-i"};